import React from 'react';

import CurrencyInput from 'react-currency-input-field';
import { Container, Label } from './styles';

function Input({ name, value, label, status, change }) {
  const handleBlur = () => {
    if (value !== undefined && value !== null && value !== '') {
      const rawNum = parseFloat(String(value).replace(',', '.'));
      if (!isNaN(rawNum)) {
        change(rawNum.toFixed(2).replace('.', ','));
      }
    }
  };

  return (
    <Container status={status.status}>
      <Label status={status.status}>{label}</Label>
      <CurrencyInput
        id={name || "input-money"}
        intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
        name={name}
        value={value}
        allowNegativeValue={false}
        disableGroupSeparators
        decimalsLimit={2}
        onValueChange={(v) => {
          const finalVal = v ? String(v).replace('.', ',') : '';
          change(finalVal);
        }}
        onBlur={handleBlur}
      />
      <div className="feedback">{status.feedback}</div>
    </Container>
  );
}

export default Input;
